import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ResumenCard = ({ icon, titulo, valor, onClick }) => (
    <div className="card-resumen" onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
        <div className="card-resumen-contenido">
            <FontAwesomeIcon icon={icon} className="icono-resumen" />
            <div className="card-texto">
                <span className="titulo-resumen">{titulo}</span>
                <span className="valor-resumen">{valor}</span>
            </div>
        </div>
    </div>
);

export default ResumenCard;